import { OidcProvider } from '@axa-fr/react-oidc';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { BrowserRouter, Navigate } from 'react-router';
import LoadingComponent from '../../components/loading/LoadingComponent';
import { queryClient } from '../api/query_client';
import { oidcConfig } from '../sso';
import AxiosProvider from './AxiosProvider';

// Composant affiché pendant le chargement initial de l'OIDC
const OidcLoadingComponent = () => {
  console.log('[OIDC] Loading...');
  return <LoadingComponent />;
};

// Composant affiché pendant l'authentification
const OidcAuthenticatingComponent = () => {
  console.log('[OIDC] Authenticating...');
  return <LoadingComponent />;
};

// Composant affiché après le callback réussi
const OidcCallbackSuccessComponent = () => {
  console.log('[OIDC] Callback success, redirecting...');
  return <LoadingComponent />;
};

// Composant affiché en cas d'erreur d'authentification
const OidcAuthenticatingErrorComponent = () => {
  console.error('[OIDC] Authentication error');
  return <Navigate to="/auth/error" replace />;
};

// Composant affiché si la session est perdue
const OidcSessionLostComponent = () => {
  console.warn('[OIDC] Session lost');
  const currentPath = window.location.pathname;
  const current = currentPath + window.location.search;
  if (currentPath !== '/auth' && !currentPath.startsWith('/auth/')) {
    sessionStorage.setItem('redirectPath', current);
  }
  return <Navigate to="/auth/login" replace />;
};

const Providers = ({ children }) => {
  // Debug: afficher la config OIDC au démarrage
  console.log('[OIDC] Configuration:', {
    authority: oidcConfig.authority,
    client_id: oidcConfig.client_id,
    redirect_uri: oidcConfig.redirect_uri,
  });

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <OidcProvider
          configuration={oidcConfig}
          loadingComponent={OidcLoadingComponent}
          authenticatingComponent={OidcAuthenticatingComponent}
          callbackSuccessComponent={OidcCallbackSuccessComponent}
          authenticatingErrorComponent={OidcAuthenticatingErrorComponent}
          sessionLostComponent={OidcSessionLostComponent}
        >
          <AxiosProvider>{children}</AxiosProvider>
        </OidcProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default Providers;
